import { config } from '../constants'
let SHOULD_LOG = config.debugLogging
let SHOULD_LOG_TRACE = config.traceLogging

try {
  let sp = new URLSearchParams(window?.location?.search ?? '')
  let consoleLog = sp.get('consolelog')
  let consoleTrace = sp.get('consoletrace')

  if (consoleLog !== null && consoleLog !== undefined) {
    SHOULD_LOG = true
  }

  if (consoleTrace !== null && consoleTrace !== undefined) {
    SHOULD_LOG_TRACE = true
  }
} catch (e) {}

const info = (...args: any[]) => {
  if (console && console.info) {
    console.info(...args)
  }
}

const log = (...args: any[]) => {
  if (console && console.log) {
    console.log(...args)
  }
}

const trace = (...args: any[]) => {
  if (console && console.trace) {
    console.trace(...args)
  }
}

const error = (...args: any[]) => {
  if (console && console.error) {
    console.error(...args)
  }
}

export function ConsoleLog(should_log: boolean, ...args: any[]) {
  if (should_log && SHOULD_LOG) {
    if (SHOULD_LOG_TRACE) {
      trace(...args)
    } else {
      log(...args)
    }
  }
}

export function ConsoleInfo(should_log: boolean, ...args: any[]) {
  if (should_log && SHOULD_LOG) {
    if (SHOULD_LOG_TRACE) {
      trace(...args)
    } else {
      info(...args)
    }
  }
}

export function ConsoleError(should_log: boolean, ...args: any[]) {
  if (should_log && SHOULD_LOG) {
    if (SHOULD_LOG_TRACE) {
      trace(...args)
    } else {
      error(...args)
    }
  }
}
